import { Component, OnInit } from '@angular/core';
import { Canal } from '../../_models/canal';
import { CanalService } from '../../_services/canal.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { CanalProductoService } from '../../_services/canal-producto.service';
import { CanalProducto } from '../../_models/canal-producto';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';
import { CanalRol } from '../../_models/canal-rol';
import { CanalRolService } from '../../_services/canal-rol.service';

@Component( {
  selector: 'app-canales-detalle',
  templateUrl: 'canales-detalle.component.html'
} )

export class CanalesDetalleComponent implements OnInit {

  canal: Canal;
  canProductos: CanalProducto[] = [];
  canRoles: CanalRol[] = [];
  carInformacionInicial = true;
  colProducto: any[];
  colRoles: any[];

  constructor( private canServicio: CanalService,
               private route: ActivatedRoute,
               private canProductoServicio: CanalProductoService,
               private canRolesServicio: CanalRolService,
               private nav: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.colProducto = [
      { field: 'codigoProducto', header: this.nav.buscarMensaje( 'CANALESPRODUCTOS.LBL_CODIGOPRODUCTO' ), sort: true },
      { field: 'nombreProducto', header: this.nav.buscarMensaje( 'CANALESPRODUCTOS.LBL_PRODUCTO' ), sort: true },
      { field: 'tipoProductoBancario', header: this.nav.buscarMensaje('PRODUCTO.LBL_TIPOPRODUCTO'), sort: true },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];

    this.colRoles = [
      { field: 'codigoRol', header: this.nav.buscarMensaje( 'CANALESROLES.LBL_CODIGOROL' ), sort: true },
      { field: 'rol', header: this.nav.buscarMensaje( 'CANALESROLES.LBL_ROL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.canServicio.obtenerPorId( params[ 'id' ] ),
        this.canProductoServicio.obtenerPorIdCanal( params[ 'id' ] ),
        this.canRolesServicio.obtenerPorIdCanal( params[ 'id' ] )
      ).subscribe( ( [ canal, canProductos, canRoles ] ) => {
        this.canal = canal;
        this.canProductos = canProductos;
        this.canRoles = canRoles;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
